import { Link, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  hr: {
    margin: "10px -10px",
    borderTop: "1px solid #ddd",
  },
}));

type NotificationMenuProps = {
  actions: { label: string; action: () => void }[];
  readingNotification: () => void;
  showClear: boolean;
};

export const NotificationMenu: React.FC<NotificationMenuProps> = ({
  actions,
  readingNotification,
  showClear,
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.hr}></div>
      &nbsp;
      {actions.map((action) => (
        <React.Fragment key={action.label}>
          <Link className="linkButton" onClick={() => action.action()}  >
            {action.label}
          </Link>
        </React.Fragment>
      ))}
      {actions.length ? " " : null}
      {showClear ? (
      <Link
        className="linkButton"
        data-test="clear-button"
        onClick={() => readingNotification()}
      >
        Clear
      </Link>
      ) : <></>}
    </React.Fragment>
  );
};
